<h1 class="title">
  <slot />
</h1>

<style lang="scss">
  .title {
    font-size: clamp(30px, 3.7vw, 60px);
    font-weight: 800;
    line-height: 140%;
  }

  @include mobile {
    .title {
      font-size: 7.7vw;
    }
  }
</style>
